import React from 'react'
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import styled from 'styled-components';
import excelIcon from '../../assets/img/ExcelIcon.svg'
import { useTranslation } from 'react-i18next'

const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 0px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    height: '32px',
    width: '32px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'white',
    color: '#7A9BC2',
    border: '1px solid #7A9BC2'
}

const ExcelButton = {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    height: '32px',
    width: '22px',
    textAlign: 'right',
    alignItems: 'right',
    justifyContent: 'center',
    background: 'white',
    color: '#7A9BC2',
    border: '1px solid #7A9BC2'
}

const TableFilterComponent = ({ filterText, onFilter, onClear, onExport }) => {
    const { t } = useTranslation();
    return (
        <>
            <Grid container item xs={12}>
                <Grid item xs={6} >
                    <ButtonGroup disableElevation variant="contained">
                        <TextField id="search" type="text" style={{ width: 205 }} placeholder={t('telematicsInstallers.registerTechnician')} aria-label="Search Input" value={filterText} onChange={onFilter} />
                        <Button type="button" variant="contained" onClick={onClear} color="primary" style={ClearButton}><b>X</b></Button>
                    </ButtonGroup>
                </Grid>
                <Grid item xs={6} style={{ textAlign: 'right' }}>
                    <ButtonGroup disableElevation variant="contained">
                        <Button type="button" variant="outlined" onClick={e => onExport(e.target.value)} style={ExcelButton}>
                            <img src={excelIcon} alt="excel-icon" width="23" height="23" />
                        </Button>
                    </ButtonGroup>
                </Grid>
            </Grid>
        </>
    )
}

export default TableFilterComponent
